export default __webpack_public_path__ + "static/media/sinister.9235a8f7.jpg";